module.exports = __webpack_public_path__ + "img/arrow-down-white.7405a354.svg";